import React, {useState, useEffect, useRef} from 'react';
import {Tag, Input, message} from 'antd';
import type {InputRef} from 'antd';
import {PlusOutlined} from '@ant-design/icons';

interface ITagComp {
    tagList: string;
    updateTagList: (tags: any) => void;
    placeholder?: string;
}
export default function TagComp(props: ITagComp) {
    const {tagList, updateTagList, placeholder} = props;
    const [tags, setTags] = useState<any>([]);
    const [inputVisible, setInputVisible] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const inputRef = useRef<InputRef>(null);

    useEffect(() => {
        if (inputVisible) {
            inputRef.current?.focus();
        }
    }, [inputVisible]);

    useEffect(() => {
        if (tagList) {
            const tempTagList = tagList.split(',');
            setTags(tempTagList);
        } else {
            setTags([]);
        }

    }, [tagList]);
    const handleClose = (removedTag: string) => {
        const newTags = tags.filter((tag) => tag !== removedTag);
        updateTagList(newTags.join(','));
    };
    const showInput = () => {
        setInputVisible(true);
    };
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value);
    };
    const handleInputConfirm = () => {
        if (tags.indexOf(inputValue) !== -1) {
            message.warning('当前输入的内容已存在');
            return;
        }
        if (inputValue && tags.indexOf(inputValue) === -1) {
            const tempValue = [...tags, inputValue];
            updateTagList(tempValue.join(','));
            setInputVisible(false);
            setInputValue('');
        }
    };

    return (<div>
        {tags.map(tag => {
            return <span key={tag} style={{display: 'inline-block'}}>
                <Tag
                    color="#409eff"
                    closable
                    onClose={(e) => {
                        e.preventDefault();
                        handleClose(tag);
                    }}
                >
                    {tag}
                </Tag>
            </span>;
        })}
        {inputVisible && (
            <Input
                ref={inputRef}
                type="text"
                size="small"
                style={{width: 78}}
                value={inputValue}
                onChange={handleInputChange}
                onBlur={handleInputConfirm}
                onPressEnter={handleInputConfirm}
            />
        )}
        {!inputVisible && (
            <Tag onClick={showInput} className="site-tag-plus">
                <PlusOutlined />{placeholder}
            </Tag>
        )}
    </div>);
}